import { SAFEConversionsGrid } from "./SAFEConversionsGrid";
import React, { useState } from "react";
import * as api from "../../../../api/generated-api";
import { DealLegalEntityInvestmentType } from "../../../../api/generated-api";
import {
  createDealLegalEntityInvestment,
  deleteDealLegalEntityInvestment,
} from "../../../../api/deallegalentityinvestment/dealLegalEntityInvestments";
import { updateDealLegalEntityInvestment } from "../../../../api/deals/investors";
import { primarySeries } from "../../../../api/deals/deals";
import { DealLegalEntityInvestmentFormEntry } from "../DealInvestorDetailPage";

type SAFEConversionsGridWrapperProps = {
  orgId: number;
  dealId: number;
  deal: api.Deal;
  dealInvestorId: number;
  canEditInvestorInfo: boolean;
  investmentDealLegalEntities: api.DealLegalEntity[];
  safeInvestments: api.DealLegalEntityInvestment[];
  setSafeInvestments: (
    fetchedInvestments: api.DealLegalEntityInvestment[]
  ) => void;
  fetchDealLegalEntityInvestments: (investorId: number) => void;
};

export const SAFEConversionsGridWrapper = (
  props: SAFEConversionsGridWrapperProps
) => {
  const {
    orgId,
    dealId,
    deal,
    dealInvestorId,
    canEditInvestorInfo,
    investmentDealLegalEntities,
    safeInvestments,
    setSafeInvestments,
    fetchDealLegalEntityInvestments,
  } = props;

  const [safeInvestmentsEditRowIndex, setSafeInvestmentsEditRowIndex] =
    useState<number>();

  const handleCancelForSAFEInvestment = () => {
    setSafeInvestmentsEditRowIndex(undefined);
    fetchDealLegalEntityInvestments(dealInvestorId);
  };

  const handleSaveForSAFEInvestment = (item: api.DealLegalEntityInvestment) => {
    if (item.id == undefined) {
      createDealLegalEntityInvestment(
        orgId,
        dealId,
        dealInvestorId,
        {
          dealSeriesId: item.dealSeriesId,
          discount: item.discount,
          purchaseAmount: item.purchaseAmount,
          shares: item.shares,
          type: DealLegalEntityInvestmentType.SAFE_Conversion,
          valuationCap: item.valuationCap,
          dealInvestorMemberSignerId: item.dealInvestorMemberSignerId,
        },
        () => {
          fetchDealLegalEntityInvestments(dealInvestorId);
        }
      );
    } else {
      const updatedSAFEs = [...safeInvestments];
      const updatedIndex = updatedSAFEs.findIndex((safe) => {
        if (safe.id == item.id) {
          return safe;
        }
      });

      const legalEntityName = investmentDealLegalEntities.find(
        (dealLegalEntity) => {
          if (dealLegalEntity.id == item.dealInvestorMemberSignerId) {
            return dealLegalEntity;
          }
        }
      ).name;

      updatedSAFEs[updatedIndex] = { ...item, name: legalEntityName };
      setSafeInvestments(updatedSAFEs);

      updateDealLegalEntityInvestment(
        orgId,
        dealId,
        dealInvestorId,
        item.id,
        {
          dealSeriesId: item.dealSeriesId,
          discount: item.discount,
          purchaseAmount: item.purchaseAmount,
          shares: item.shares,
          type: DealLegalEntityInvestmentType.SAFE_Conversion,
          valuationCap: item.valuationCap,
          dealInvestorMemberSignerId: item.dealInvestorMemberSignerId,
        },
        () => {
          fetchDealLegalEntityInvestments(dealInvestorId);
        }
      );
    }

    setSafeInvestmentsEditRowIndex(undefined);
  };

  const handleEditForSAFEInvestment = (index: number) => {
    setSafeInvestmentsEditRowIndex(index);
  };

  const handleAddForSAFEInvestment = () => {
    const newItem: api.DealLegalEntityInvestment = {
      createdAt: undefined,
      dealInvestorMemberSignerId: undefined,
      investorId: undefined,
      legalEntityId: undefined,
      name: "",
      shares: 0,
      dealSeriesId: primarySeries(deal).id,
      signatureBlock: undefined,
      signatureBlockId: 0,
      signer: undefined,
      split: 0,
      type: api.DealLegalEntityInvestmentType.SAFE_Conversion,
      updatedAt: undefined,
      wireDateReceived: undefined,
      id: undefined,
      valuationCap: 0,
      discount: 0,
      purchaseAmount: 0,
    };
    const newRows = [...safeInvestments, newItem];
    setSafeInvestments(newRows);
    setSafeInvestmentsEditRowIndex(newRows.length - 1);
  };

  const handleRemoveForSAFEInvestment = (
    dealLegalEntityInvestmentFormEntry: DealLegalEntityInvestmentFormEntry
  ) => {
    // optimistically delete from  state
    setSafeInvestments(
      safeInvestments.filter(
        (safeInvestment) =>
          safeInvestment.id !== dealLegalEntityInvestmentFormEntry.id
      )
    );
    // exit edit mode
    handleCancelForSAFEInvestment();

    // delete from API
    deleteDealLegalEntityInvestment(
      orgId,
      dealId,
      dealInvestorId,
      dealLegalEntityInvestmentFormEntry.id
    );
  };

  return (
    <SAFEConversionsGrid
      deal={deal}
      dealInvestorId={dealInvestorId}
      dealLegalEntitiesOfInvestor={investmentDealLegalEntities}
      items={safeInvestments}
      editRowIndex={safeInvestmentsEditRowIndex}
      canEditInvestorInfo={canEditInvestorInfo}
      onCancel={handleCancelForSAFEInvestment}
      onAdd={handleAddForSAFEInvestment}
      onSave={handleSaveForSAFEInvestment}
      onEdit={handleEditForSAFEInvestment}
      onRemove={handleRemoveForSAFEInvestment}
    />
  );
};
